import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const semesterListByCourse = createAsyncThunk('semesterListByCourse', async ({ data, navigate, status }) => {
    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `semester_list_by_filters?status=${status || ''}`,
            params: {
                'session_id': data.session_id,
                'course_id': data.course_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const semesterListByCourseSlice = createSlice({
    name: 'semesterListByCourse',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(semesterListByCourse.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(semesterListByCourse.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default semesterListByCourseSlice.reducer;
